import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import LoadingScreen from '../LoadingScreen/LoadingScreen';

const ProtectedRoute = ({ children, requireAuth = true }) => {
  const { isAuthenticated, isInitialized } = useSelector(state => state.auth);

  // If auth state hasn't been initialized yet, show loading
  // This should only happen very briefly during app startup
  if (!isInitialized) {
    return <LoadingScreen message="Verifying authentication..." />;
  }

  if (requireAuth && !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!requireAuth && isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute; 